import { fromBech32 } from "@cosmjs/encoding";
import { getWallet } from "../wallet";
import { useChainStore } from "../shared/store";
export const isCosmosAddress = (address, prefix) => {
    try {
        const decoded = fromBech32(address);
        if (decoded.data.length === 20 || decoded.data.length === 32) {
            return prefix !== undefined ? decoded.prefix === prefix : true;
        }
        return false;
    }
    catch {
        return false;
    }
};
export const suggestChain = async (args) => {
    const wallet = getWallet(args.walletType);
    await wallet.provider().experimentalSuggestChain?.(args.chainInfo);
};
export const getChainInfo = (chainId) => {
    return useChainStore
        .getState()
        .chains.find((chain) => chain.chainId === chainId);
};
//# sourceMappingURL=chain.js.map